module.exports = __webpack_public_path__ + "static/media/EG-P0flow.6350a4e2.jpg";